import React, { useEffect, useState } from "react";
import { Form, Button, Collapse, Container, ButtonGroup, ToggleButton } from 'react-bootstrap';
import { useFormik } from "formik";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
// import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { useTranslation } from 'react-i18next';
import idGif from "../assets/identification.gif";
import detailsGif from "../assets/details.gif";
import verifyGif from "../assets/verify.gif";



const validateDayVisitorForm = (empData) => {
    const errors = {};

    if (document.getElementById('idPassportIdentity').checked) {
        if (!empData.Foreignpass) {
            errors.Foreignpass = "Please Enter Valid Foreign Passport.";
        }
    }

    if (document.getElementById('idNricIdentity').checked) {
        if (!empData.NRIC) {
            errors.NRIC = "Please Enter NRIC.";
        }
    }


    if (!empData.VisitorFullName) {
        errors.VisitorFullName = "Please Enter Visitor Name."
    }

    if (!empData.ContactNo) {
        errors.ContactNo = "Please Enter Contact Number."
    }

    if (!empData.PatientFirstName) {
        errors.PatientFirstName = "Please Enter Patients First Name."
    }

    if (!empData.PatientLastName) {
        errors.PatientLastName = "Please Enter Patients Last Name."
    }

    if (!empData.PatientWard) {
        errors.PatientWard = "Please Enter Patients Ward Information."
    }

    if (!empData.PatientRoom) {
        errors.PatientRoom = "Please Enter Patients Room Information."
    }

    if (!empData.PatientBed) {
        errors.PatientBed = "Please Enter Patients Bed Information."
    }

    if (!empData.BotCaptcha) {
        errors.BotCaptcha = "Please Enter Captcha code.";
    }

    let user_captcha_value = document.getElementById('BotCaptcha').value;
    if (validateCaptcha(user_captcha_value, false) === false) {
        errors.BotCaptcha = "Captcha Does Not Match";
    }

    return errors;
}

const correctShowBoxinfo = () => {

}


const DayVisitorForm = () => {
    const { t } = useTranslation(); // LANGUAGE    
    const [toggleActive, setBot] = useState(false); //Toggle Captcha

    const [displayInputPassport, setdisplayInputPassport] = useState("none");
    const [displayInputNric, setdisplayInputNric] = useState("block");

    const [displayInfoBox, setdisplayInfoBox] = useState("none") // information box

    // none, inline, block, inline-block
    const [displayBack, setdisplayBack] = useState("none");
    const [displayBack2, setdisplayBack2] = useState("none");
    const [displayBack3, setdisplayBack3] = useState("none"); // button back3
    const [displayNext, setdisplayNext] = useState("block");
    const [displayNext2, setdisplayNext2] = useState("none");
    const [displayNext3, setdisplayNext3] = useState("none");
    // const [displayCancel, setdisplayCancel] = useState("block");
    const [displaySubmit, setdisplaySubmit] = useState("none"); // button submit
    const [displayFormOne, setdisplayFormOne] = useState("block") // show inital form 1 section - visitor
    const [displayFormTwo, setdisplayFormTwo] = useState("none")
    const [displayFormQa, setdisplayFormQa] = useState("none")
    const [displayConfirmation, setdisplayConfirmation] = useState("none")

    const [radioValueOne, setRadioValueOne] = useState('1');  // Questionaire radio option
    const [radioValueTwo, setRadioValueTwo] = useState('1');  // Questionaire radio option
    const [radioValueThree, setRadioValueThree] = useState('1');  // Questionaire radio option


    const [diplayMessageOne, setdiplayMessageOne] = useState("none") // first message enter


    const radiosOne = [
        { name: 'YES', value: '1' },
        { name: 'NO', value: '2' },
    ];

    const radiosTwo = [
        { name: 'YES', value: '1' },
        { name: 'NO', value: '2' },
    ];

    const radiosThree = [
        { name: 'YES', value: '1' },
        { name: 'NO', value: '2' },
    ];


    //SELECT OPTIONS (Radio)
    const handleIdentification = (e) => {
        console.log(e.target.value);

        if (e.target.value === "Passport") {
            setdisplayInputPassport("block");
            setdisplayInputNric("none")


        }

        if (e.target.value === "NRIC") {
            setdisplayInputNric("block");
            setdisplayInputPassport("none");
        }

    }

    //CAPTCHA HANDLE (Checkbox)
    const handleBotChange = (e) => {
        setBot(e.target.checked);
        // console.log("I'm not a BOT : " + e.target.checked);
    }


    const GoNextForm = (e) => {

        let ValIdentification;
        if (document.getElementById('idPassportIdentity').checked) {
            console.log("idPassportIdentity: Checked")
            ValIdentification = document.getElementById('idPassport').value;
        } else if (document.getElementById('idNricIdentity').checked) {
            console.log("idNricIdentity: Checked")
            ValIdentification = document.getElementById('idNricFin').value;
        }

        let visitorNameVal = document.getElementById('idVisitorFullName').value;
        let idContact = document.getElementById('idContact').value;
        //GET VALUES :  
        if (ValIdentification === "" || visitorNameVal === "" || idContact === "") {
            //Show text value your can't proceed
            setdiplayMessageOne("block");

        } else {
            setdiplayMessageOne("none");

            setdisplayBack("block");
            setdisplayFormTwo("block");
            setdisplaySubmit("none");
            setdisplayNext("none");
            setdisplayNext2("block");

            document.getElementById('idStepSection2').classList.add("backgroundtoGreen");

            //icons 2nd Step
            document.getElementById('firstIcon').style.display = "none";
            document.getElementById('secondIcon').style.display = "block";
            document.getElementById('thirdIcon').style.display = "none";

            //Form Disabled Step 1 (ic, pass, visitor name, contact)
            document.getElementById('idNricFin').disabled = true;
            document.getElementById('idPassport').disabled = true;
            document.getElementById('idNricIdentity').disabled = true;
            document.getElementById('idPassportIdentity').disabled = true;
            document.getElementById('idVisitorFullName').disabled = true;
            document.getElementById('idContact').disabled = true;
        }


    }

    const GoNextForm2 = (e) => {

        let pfirstName = document.getElementById('idPatientFirstName').value;
        let plastName = document.getElementById('idPatientLastName').value;
        let pward = document.getElementById('idPatientWard').value;
        let proom = document.getElementById('idPatientRoom').value;
        let pbed = document.getElementById('idPatientBed').value;
        //GET VALUES :  
        if (pfirstName === "" || plastName === "" || pward === "" || proom === "" || pbed === "") {
            //Show text value your can't proceed
            setdiplayMessageOne("block");
        } else {
            setdiplayMessageOne("none");

            //BUTTONS
            setdisplayBack("none");
            setdisplayBack2("none");
            setdisplayBack3("block")
            setdisplayFormTwo("block");
            setdisplaySubmit("block");
            setdisplayNext("none");
            setdisplayNext2("none");


            //FORMS - VALIDATE FIRST
            //Hide previous input fields and show the info   (infobox entered info)
            setdisplayFormOne("none");
            setdisplayFormTwo("none");
            setdisplayInfoBox("block")

            //Other Default
            setdisplayFormQa("block"); // dipslay questionaire
            setdisplayConfirmation("block"); // recaptcha

            // document.getElementById('idStepSection2').classList.add("backgroundtoGreen");

            //icons 2nd Step
            document.getElementById('firstIcon').style.display = "none";
            document.getElementById('secondIcon').style.display = "none";
            document.getElementById('thirdIcon').style.display = "block";

            //Form Disabled Step 2 (location, Visit Date, TIme, Purpose, Refer)
            // document.getElementById('idSelectLocation').disabled = true;
            document.getElementById('idPatientFirstName').disabled = true;
            document.getElementById('idPatientLastName').disabled = true;
            document.getElementById('idPatientWard').disabled = true;
            document.getElementById('idPatientRoom').disabled = true;
            document.getElementById('idPatientBed').disabled = true;
        }


    }

    // The Questionaire
    const GoNextForm3 = (e) => {
        setdiplayMessageOne("none");

        setdisplayBack("none");
        setdisplayBack2("block");
        setdisplayFormTwo("block");
        setdisplaySubmit("block");
        setdisplayNext("none");
        setdisplayNext2("none");
        // setdisplayNext3("block");
        setdisplayConfirmation("none");//green button

        //icons 2nd Step
        document.getElementById('firstIcon').style.display = "none";
        document.getElementById('secondIcon').style.display = "none";
        document.getElementById('thirdIcon').style.display = "block";

        //Form Disabled Step 2 (location, Visit Date, TIme, Purpose, Refer)
        // document.getElementById('idSelectLocation').disabled = true;
        document.getElementById('idPatientFirstName').disabled = true;
        document.getElementById('idPatientLastName').disabled = true;
        document.getElementById('idPatientWard').disabled = true;
        document.getElementById('idPatientRoom').disabled = true;
        document.getElementById('idPatientBed').disabled = true;

    }

    const GoBackForm = (e) => {
        // alert("GoBackForm");

        setdiplayMessageOne("none");


        setdisplayBack("none");
        setdisplayBack2("none");
        setdisplayFormTwo("none");
        setdisplaySubmit("none");
        setdisplayNext("block");
        setdisplayNext2("none");
        setdisplayNext3("none") //questionaire
        setdisplayConfirmation("none");

        document.getElementById('idStepSection2').classList.remove("animate__animated");
        document.getElementById('idStepSection2').classList.remove("backgroundtoGreen");
        window.scrollTo(0, 0); // values are x,y-offset

        // From Second Step
        // icons 
        document.getElementById('firstIcon').style.display = "block";
        document.getElementById('secondIcon').style.display = "none";
        document.getElementById('thirdIcon').style.display = "none";

        //Form Enabled back Step 1 (ic, pass, visitor name, contact)
        document.getElementById('idNricFin').disabled = false;
        document.getElementById('idPassport').disabled = false;
        document.getElementById('idNricIdentity').disabled = false;
        document.getElementById('idPassportIdentity').disabled = false;
        document.getElementById('idVisitorFullName').disabled = false;
        document.getElementById('idContact').disabled = false;
    }

    const GoBackForm2 = (e) => {
        // alert("GoBackForm2");

        setdiplayMessageOne("none");

        //Hide InfoBox 
        setdisplayInfoBox("none")

        setdisplayBack("none");
        setdisplayBack2("none");
        setdisplayBack3("none");
        setdisplayFormOne("block");
        setdisplayFormTwo("none");
        setdisplaySubmit("none");
        setdisplayNext("block");
        setdisplayNext2("none");
        setdisplayNext3("none"); // questionaire - no need 
        setdisplayConfirmation("none");

        window.scrollTo(0, 0); // values are x,y-offset

        document.getElementById('idStepSection2').classList.remove("animate__animated");
        document.getElementById('idStepSection2').classList.remove("backgroundtoGreen");
        window.scrollTo(0, 0); // values are x,y-offset

        // From Second Step
        // icons 
        document.getElementById('firstIcon').style.display = "block";
        document.getElementById('secondIcon').style.display = "none";
        document.getElementById('thirdIcon').style.display = "none";


        //From Second Step
        //Form Enabled Step 2 (Pfirstname, Plastname, Pward, Proom, Pbed)
        document.getElementById('idPatientFirstName').disabled = false;
        document.getElementById('idPatientLastName').disabled = false;
        document.getElementById('idPatientWard').disabled = false;
        document.getElementById('idPatientRoom').disabled = false;
        document.getElementById('idPatientBed').disabled = false;

        document.getElementById('idNricFin').disabled = false;
        document.getElementById('idPassport').disabled = false;
        document.getElementById('idNricIdentity').disabled = false;
        document.getElementById('idPassportIdentity').disabled = false;
        document.getElementById('idVisitorFullName').disabled = false;
        document.getElementById('idContact').disabled = false;


    }

    const GoBackForm3 = (e) => {

        setdiplayMessageOne("none");
        // alert("GoBackForm3");

        //From current Questionaire to Patient input
        setdisplayBack("none");
        setdisplayBack2("block");
        setdisplayBack3("none");
        setdisplayFormOne("block");
        setdisplayFormTwo("block");
        setdisplayFormQa("none");
        setdisplayNext2("block");
        setdisplaySubmit("none");
        setdisplayConfirmation("none");

        window.scrollTo(0, 0); // values are x,y-offset

        // // From Second Step
        // // icons 
        // document.getElementById('firstIcon').style.display = "none";
        // document.getElementById('secondIcon').style.display = "block";
        // document.getElementById('thirdIcon').style.display = "none";

        document.getElementById('idNricFin').disabled = true;
        document.getElementById('idPassport').disabled = true;
        document.getElementById('idNricIdentity').disabled = true;
        document.getElementById('idPassportIdentity').disabled = true;
        document.getElementById('idVisitorFullName').disabled = true;
        document.getElementById('idContact').disabled = true;


        // //From Second Step
        // //Form Enabled Step 2 (Pfirstname, Plastname, Pward, Proom, Pbed) 
        document.getElementById('idPatientFirstName').disabled = false;
        document.getElementById('idPatientLastName').disabled = false;
        document.getElementById('idPatientWard').disabled = false;
        document.getElementById('idPatientRoom').disabled = false;
        document.getElementById('idPatientBed').disabled = false;

        //icons 2nd Step
        document.getElementById('firstIcon').style.display = "none";
        document.getElementById('secondIcon').style.display = "block";
        document.getElementById('thirdIcon').style.display = "none";


        //Hide InfoBox 
        setdisplayInfoBox("none")
    }


    useEffect(() => {
        loadCaptchaEnginge(4);
    }, []); // EMPTY ARRAY 
    const formik = useFormik({
        initialValues: {
            NRIC: "",
            Foreignpass: "",
            VisitorFullName: "",
            ContactNo: "",
            PatientFirstName: "",
            PatientLastName: "",
            PatientWard: "",
            PatientRoom: "",
            PatientBed: "",
            BotCaptcha: "",
        },
        validate: validateDayVisitorForm,
        validateOnBlur: true, // and this one
        onSubmit: (values) => {

            console.log(JSON.stringify(values));

            //2nd validation 
            let user_captcha_value = document.getElementById('BotCaptcha').value;
            if (validateCaptcha(user_captcha_value, false) === true) {
                console.log('.. GO to SUCCESSFUL PAGE')
                window.location.href = "/Successful";
            }
            else {
                console.log("....")
            }
        }
    });
    return (
        <Container>
            <div className="row">

                {/* COLUMN 2 ICONS */}
                <div className="col-md-6 col-sm-12 order-md-12 order-xs-1 ">
                    <div className="container icon-box-form animate__animated animate__fadeIn  animate__delay-900ms the-icons">

                        <div id="firstIcon" className="firstIconClass">
                            <img src={idGif} className="mx-auto d-block img-responsive img-thumbnail icon-img mobile-icon-img" alt="icon" />
                        </div>
                        <div id="secondIcon" className="secondIconClass">
                            <img src={detailsGif} className="mx-auto d-block img-responsive img-thumbnail icon-img2 mobile-icon-img2" alt="icon" />
                        </div>
                        <div id="thirdIcon" className="thirdIconClass">
                            <img src={verifyGif} className="mx-auto d-block img-responsive img-thumbnail icon-img3 mobile-icon-img3" alt="icon" />
                        </div>
                    </div>
                </div>
                {/* END COLUMN 2 ICONS */}


                {/* COLUMN 1 FORM SECTION */}
                <div className="col-sm-12 col-md-6 order-md-1 order-xs-12 formHeight" >


                    {/* =========== INFORMATION BOX ========== */}
                    <div className="infoBox" style={{ display: displayInfoBox }}>
                        <div className="Appointment-content animate__animated animate__fadeInUp animate__delay-500ms">

                            <h4>
                                {/* Your Regration Details: */}
                                <span>{t('text.50')}</span>
                            </h4>
                            <div className="row container appt-text">

                                <div className="row container infoContent">
                                    <div className="col-sm-12 col-md-12">
                                        <h6><b> Visitor Information </b></h6>
                                    </div>

                                    <div className="col-sm-12 col-md-6">
                                        {/* NRIC/FIN */}
                                        <span>{t('text.52')}</span> <span>{formik.values.NRIC}</span>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        {/* Visitor Name: */}
                                        <span>{t('text.54')}</span> <span>{formik.values.VisitorFullName}</span>
                                    </div>
                                    <div className="col-sm-12 col-md-12">
                                        {/* Contact No.: */}
                                        <span>{t('text.53')}</span> <span>{formik.values.ContactNo}</span>
                                    </div>
                                </div>

                                <div className="row container infoContent">
                                    <div className="col-sm-12 col-md-12">
                                        <h6><b> Patient Information </b></h6>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        {/* First Name : */}
                                        <span>{t('text.72')}</span> <span>{formik.values.PatientFirstName}</span>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        {/* Last Name : */}
                                        <span>{t('text.73')}</span> <span>{formik.values.PatientLastName}</span>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        {/* Patient's Ward : */}
                                        <span>{t('text.13')}</span> <span>{formik.values.PatientWard}</span>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        {/* Patient's Room : */}
                                        <span>{t('text.59')}</span> <span>{formik.values.PatientRoom}</span>
                                    </div><div className="col-sm-12 col-md-6">
                                        {/* Patient's Bed : */}
                                        <span>{t('text.60')}</span> <span>{formik.values.PatientBed}</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <br />
                    </div>



                    <Form onSubmit={formik.handleSubmit}>

                        {/* ====== 1stSTEP ======= */}
                        <div className="Visitor-Section" style={{ display: displayFormOne }}>
                            <Form.Row>
                                <Form.Group className="col-sm-12 col-md-12">
                                    <Form.Label>
                                        <b>
                                            {/* * Select Identification Type:  */}
                                            {t('text.4')}
                                        </b>
                                    </Form.Label>
                                    <div className="form-check radioHeight">
                                        <input
                                            id="idNricIdentity"
                                            className="form-check-input"
                                            type="radio"
                                            name="PickedId"
                                            value="NRIC"
                                            defaultChecked
                                            onChange={handleIdentification}
                                        />
                                        <label className="form-check-label" for="inlineRadio1">
                                            {/* NRIC/FIN */}
                                            {t('text.5')}
                                        </label>
                                    </div>
                                    <div className="form-check radioHeight">
                                        <input
                                            id="idPassportIdentity"
                                            className="form-check-input"
                                            type="radio"
                                            name="PickedId"
                                            value="Passport"
                                            onChange={handleIdentification}
                                        />
                                        <label className="form-check-label" for="inlineRadio2">
                                            {/* Foreign Passport No.  */}
                                            {t('text.6')}
                                        </label>
                                    </div>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row style={{ display: displayInputNric }}>
                                {/* NRIC */}
                                <Form.Group className="col-sm-12 col-md-12">
                                    <Form.Label>
                                        {/* Enter NRIC/FIN : */}
                                        {t('text.7')}
                                    </Form.Label>
                                    <div id="idNricFinText" className="the-form-text">
                                        <p>{formik.values.NRIC}</p>
                                    </div>
                                    <Form.Control
                                        id="idNricFin"
                                        name="NRIC"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.NRIC}
                                        placeholder="(e.g S5352749P)"
                                    />
                                    {formik.touched.NRIC && formik.errors.NRIC ? (
                                        <span style={{ color: "red" }}>{formik.errors.NRIC}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>

                            <Form.Row style={{ display: displayInputPassport }}>
                                {/* PASSPORT */}
                                <Form.Group className="col-sm-12 col-md-12">
                                    <Form.Label>
                                        {/* Enter Foreign Passport No. : */}
                                        {t('text.8')}
                                    </Form.Label>
                                    <div id="idPassportText" className="the-form-text">
                                        <p>{formik.values.Foreignpass}</p>
                                    </div>
                                    <Form.Control
                                        id="idPassport"
                                        name="Foreignpass"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Foreignpass}
                                        placeholder=""
                                    />
                                    {formik.touched.Foreignpass && formik.errors.Foreignpass ? (
                                        <span style={{ color: "red" }}>{formik.errors.Foreignpass}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group className="col-sm-12 col-md-12" >
                                    <Form.Label>
                                        {/* Visitor Name: */}
                                        {t('text.10')}
                                    </Form.Label>
                                    <div id="idVisitorFullNameText" className="the-form-text">
                                        <p>{formik.values.VisitorFullName}</p>
                                    </div>
                                    <Form.Control
                                        id="idVisitorFullName"
                                        name="VisitorFullName"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.VisitorFullName}
                                        placeholder="Visitor's Full Name"
                                        rows="3" />
                                    {formik.touched.VisitorFullName && formik.errors.VisitorFullName ? (
                                        <span style={{ color: "red" }}>{formik.errors.VisitorFullName}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group className="col-sm-12 col-md-12">
                                    <Form.Label>
                                        {/* Contact No.: */}
                                        {t('text.9')}
                                    </Form.Label>
                                    <div id="idContactText" className="the-form-text">
                                        <p>{formik.values.ContactNo}</p>
                                    </div>
                                    <Form.Control
                                        id="idContact"
                                        name="ContactNo"
                                        type="number"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.ContactNo}
                                        placeholder="(e.g. 90525505)"
                                        maxLength="2" />
                                    {formik.touched.ContactNo && formik.errors.ContactNo ? (
                                        <span style={{ color: "red" }}>{formik.errors.ContactNo}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>
                        </div>



                        {/* ====== 2nd STEP (FORM TWO)======= */}
                        <div className="Patients-Section" style={{ display: displayFormTwo }}>
                            <hr />
                            <h5>Patient Details:</h5>

                            <Form.Row>
                                {/* PATIENTS FIRST NAME */}
                                <Form.Group className="col-sm-12 col-md-12" >
                                    <Form.Label>
                                        {/* First Name: */}
                                        {t('text.72')}
                                    </Form.Label>
                                    <div id="idPatientFirstNameText" className="the-form-text">
                                        <p>{formik.values.PatientFirstName}</p>
                                    </div>
                                    <Form.Control
                                        id="idPatientFirstName"
                                        name="PatientFirstName"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.PatientFirstName}
                                        placeholder="Patient First Name"
                                        rows="3" />
                                    {formik.touched.PatientFirstName && formik.errors.PatientFirstName ? (
                                        <span style={{ color: "red" }}>{formik.errors.PatientFirstName}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                {/* PATIENTS LAST NAME */}
                                <Form.Group className="col-sm-12 col-md-12" >
                                    <Form.Label>
                                        {/* Last Name : */}
                                        {t('text.73')}
                                    </Form.Label>
                                    <div id="idPatientLastNameText" className="the-form-text">
                                        <p>{formik.values.PatientLastName}</p>
                                    </div>
                                    <Form.Control
                                        id="idPatientLastName"
                                        name="PatientLastName"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.PatientLastName}
                                        placeholder="Patient Last Name"
                                        rows="3" />
                                    {formik.touched.PatientLastName && formik.errors.PatientLastName ? (
                                        <span style={{ color: "red" }}>{formik.errors.PatientLastName}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>


                            <Form.Row>
                                {/* PATIENTS WARD */}
                                <Form.Group className="col-xs-4 col-md-4" >
                                    <Form.Label>
                                        {/* Patient's Ward : */}
                                        {t('text.13')}
                                    </Form.Label>
                                    <div id="idPatientWardText" className="the-form-text">
                                        <p>{formik.values.PatientWard}</p>
                                    </div>
                                    <Form.Control
                                        id="idPatientWard"
                                        name="PatientWard"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.PatientWard}
                                        placeholder="01, 55, 66, 77"
                                        rows="3" />
                                    {formik.touched.PatientWard && formik.errors.PatientWard ? (
                                        <span style={{ color: "red" }}>{formik.errors.PatientWard}</span>
                                    ) : null}
                                </Form.Group>

                                {/* PATIENTS ROOM */}
                                <Form.Group className="col-xs-4 col-md-4" >
                                    <Form.Label>
                                        {/* Patient's Room : */}
                                        {t('text.59')}
                                    </Form.Label>
                                    <div id="idPatientRoomText" className="the-form-text">
                                        <p>{formik.values.PatientRoom}</p>
                                    </div>
                                    <Form.Control
                                        id="idPatientRoom"
                                        name="PatientRoom"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.PatientRoom}
                                        placeholder="01, 55, 66, 77"
                                        rows="3" />
                                    {formik.touched.PatientRoom && formik.errors.PatientRoom ? (
                                        <span style={{ color: "red" }}>{formik.errors.PatientRoom}</span>
                                    ) : null}
                                </Form.Group>

                                {/* PATIENTS BED */}
                                <Form.Group className="col-xs-4 col-md-4" >
                                    <Form.Label>
                                        {/* Patient's Bed : */}
                                        {t('text.60')}
                                    </Form.Label>
                                    <div id="idPatientBedText" className="the-form-text">
                                        <p>{formik.values.PatientBed}</p>
                                    </div>
                                    <Form.Control
                                        id="idPatientBed"
                                        name="PatientBed"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.PatientBed}
                                        placeholder="01, 55, 66, 77"
                                        rows="3" />
                                    {formik.touched.PatientBed && formik.errors.PatientBed ? (
                                        <span style={{ color: "red" }}>{formik.errors.PatientBed}</span>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>

                        </div>



                        {/* ============ 3rd STEP Questionaire first FROM STEP2 =========== */}
                        <div className="questionaire-section animate__animated animate__fadeIn" style={{ display: displayFormQa }}>

                            <hr />
                            <h5>Questionaire:</h5>

                            <div className="container questionaire">
                                <ul>
                                    <li>
                                        <div className="row">
                                            <h6>Q1: Travel Info</h6>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                <p>Did you travel to China?</p>
                                            </div>
                                            <div className="col-sm-12 col-md-6 questionaireRadio">
                                                {/* RADIO OPTIONS */}
                                                <ButtonGroup>
                                                    {radiosOne.map((radio, idx) => (
                                                        <ToggleButton
                                                            key={idx}
                                                            id={`radio-${idx}`}
                                                            type="radio"
                                                            variant={idx % 2 ? 'outline-dark' : 'outline-dark'}
                                                            name="radio"
                                                            value={radio.value}
                                                            checked={radioValueOne === radio.value}
                                                            onChange={(e) => setRadioValueOne(e.currentTarget.value)}
                                                        >
                                                            <span className="radioBtnName">
                                                                {radio.name}
                                                            </span>
                                                        </ToggleButton>
                                                    ))}
                                                </ButtonGroup>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="row">
                                            <h6>Q2: Contact Info</h6>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                <p>Did you come in contact with any COVID person?</p>
                                            </div>
                                            <div className="col-sm-12 col-md-6 questionaireRadio">
                                                {/* RADIO OPTIONS */}
                                                <ButtonGroup>
                                                    {radiosTwo.map((radio, idx) => (
                                                        <ToggleButton
                                                            key={idx}
                                                            id={`radio-${idx}`}
                                                            type="radio"
                                                            variant={idx % 2 ? 'outline-dark' : 'outline-dark'}
                                                            name="radio"
                                                            value={radio.value}
                                                            checked={radioValueTwo === radio.value}
                                                            onChange={(e) => setRadioValueTwo(e.currentTarget.value)}
                                                        >
                                                            <span className="radioBtnName">
                                                                {radio.name}
                                                            </span>
                                                        </ToggleButton>
                                                    ))}
                                                </ButtonGroup>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="row">
                                            <h6>Q3: Fall Info</h6>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                                <p>Did you had a fall in the past 6 months?</p>
                                            </div>
                                            <div className="col-sm-12 col-md-6 questionaireRadio">
                                                {/* RADIO OPTIONS */}
                                                <ButtonGroup>
                                                    {radiosThree.map((radio, idx) => (
                                                        <ToggleButton
                                                            key={idx}
                                                            id={`radio-${idx}`}
                                                            type="radio"
                                                            variant={idx % 2 ? 'outline-dark' : 'outline-dark'}
                                                            name="radio"
                                                            value={radio.value}
                                                            checked={radioValueThree === radio.value}
                                                            onChange={(e) => setRadioValueThree(e.currentTarget.value)}
                                                        >
                                                            <span className="radioBtnName">
                                                                {radio.name}
                                                            </span>
                                                        </ToggleButton>
                                                    ))}
                                                </ButtonGroup>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                        </div>






                        {/* ====== CONFIRMATION LAST PROCEDURE FROM STEP2 ======= */}
                        <div className="confirmation-section" style={{ display: displayConfirmation }}>

                            {/* ====== 3rd STEP (Confirm before Submit)======= */}
                            {/* THE ALL SHOULD BE IN TEXT FORM */}
                            {/* SHOWING, Back button, final icon, submit button, cancel */}
                            <Form.Row>
                                <div className="col-sm-12 col-md-10 confirm-text2">
                                    {/* <p>*NOTE: Verify your information before you continue, 
                                        Click 'Confirm' to Submit your appointment.</p> */}
                                    <p>{t('text.49')}</p>
                                </div>
                                <Form.Group className="col-sm-3">
                                    <Form.Label>
                                        {/* I'm Not a Robot : */}
                                        {t('text.15')}
                                    </Form.Label>
                                    <Form.Control
                                        id="ImNotaBot"
                                        name="ImNotaBot"
                                        type="checkbox"
                                        onChange={handleBotChange}
                                        checked={toggleActive}
                                        className="toggle-class"
                                    />
                                </Form.Group>
                            </Form.Row>

                            <Collapse in={toggleActive}>
                                <Form.Row>
                                    <Form.Group className="col-md-10" >
                                        <LoadCanvasTemplate />
                                        <Form.Label>
                                            {/* I'm Not a Robot : */}
                                            {t('text.16')}
                                        </Form.Label>
                                        <Form.Control
                                            id="BotCaptcha"
                                            name="BotCaptcha"
                                            type="text"
                                            onChange={formik.handleChange}
                                            value={formik.values.BotCaptcha}
                                            placeholder="Enter Captcha Code" />
                                        {formik.touched.BotCaptcha && formik.errors.BotCaptcha ? (
                                            <span style={{ color: "red" }}>{formik.errors.BotCaptcha}</span>
                                        ) : null}
                                    </Form.Group>
                                </Form.Row>
                            </Collapse>
                        </div>

                        <br />
                        <Form.Row>


                            {/* MESSAGE VISITOR and PATIENTS DETAILS  */}
                            <div className="col-sm-12 col-md-10 confirm-text" style={{ display: diplayMessageOne }}>
                                {/* <p>*NOTE: Verify your information before you continue, 
                                        Click 'Confirm' to Submit your appointment.</p> */}
                                <p>{t('text.71')}</p>
                            </div>


                            <div
                                className="btn-toolbar"
                                role="toolbar"
                                aria-label="Toolbar with button groups"
                            >
                                {/* VISITOR SECITON  */}
                                {/* THIS BUTTON SHOW ON STEP 2 and 3 */}
                                <div
                                    style={{ display: displayBack }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="First group"
                                >
                                    <Button
                                        onClick={GoBackForm}
                                        className="btn btn-info btn-block"
                                        type="button"
                                        id="idBackBtn"
                                    >
                                        {/* BACK1 */}
                                        {t('text.17')}
                                    </Button>
                                </div>

                                {/* PATIENT SECITON  */}
                                <div
                                    style={{ display: displayBack2 }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="First group"
                                >
                                    <Button
                                        onClick={GoBackForm2}
                                        className="btn btn-info btn-block"
                                        type="button"
                                        id="idBackBtn2"
                                    >
                                        {/* BACK2 */}
                                        {t('text.17')}
                                    </Button>
                                </div>

                                {/* QUESTIONAIRES SECITON  */}
                                <div
                                    style={{ display: displayBack3 }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="Third group"
                                >
                                    <Button
                                        onClick={GoBackForm3}
                                        className="btn btn-info btn-block"
                                        type="button"
                                        id="idBackBtn"
                                    >
                                        {/* BACK3 */}
                                        {t('text.17')}
                                    </Button>
                                </div>


                                <div
                                    style={{ display: displayNext }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="First group"
                                >
                                    <Button
                                        onClick={GoNextForm}
                                        className="btn btn-primary btn-block"
                                        type="button"
                                        id="idNextBtn"
                                    >
                                        {/* Next */}
                                        {t('text.18')}
                                    </Button>
                                </div>


                                <div
                                    style={{ display: displayNext2 }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="First group"
                                >
                                    <Button
                                        onClick={GoNextForm2}
                                        className="btn btn-primary btn-block"
                                        type="button"
                                        id="idNextBtn2"
                                    >
                                        {/* NEXT 2 */}
                                        {t('text.18')}
                                    </Button>
                                </div>

                                {/* <div
                                    style={{ display: displayNext3 }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="First group"
                                >
                                    <Button
                                        onClick={GoNextForm3}
                                        className="btn btn-primary btn-block"
                                        type="button"
                                        id="idNextBtn2"
                                    >
                                        Next button 3
                                        {t('text.18')}
                                    </Button>
                                </div> */}

                                <div
                                    // style={{ display: this.state.displayCancel }}
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="Second group"
                                >
                                    <Button
                                        className="btn btn-danger btn-block"
                                        type="cancel"
                                        href="/Unsuccessful"
                                        id="idCancelBtn"
                                    >
                                        {/* Cancel */}
                                        {t('text.19')}
                                    </Button>
                                </div>


                                {/* THIS BUTTON SHOW ON STEP 3 */}
                                <div
                                    style={{ display: displaySubmit }}
                                    id="submitBtn"
                                    className="btn-group mr-3"
                                    role="group"
                                    aria-label="First group"
                                >
                                    <Button
                                        className="btn btn-success btn-block"
                                        type="submit"
                                    // ref="/Successful" 
                                    >
                                        {/* Submit  */}
                                        {t('text.20')}
                                    </Button>
                                </div>

                            </div>
                        </Form.Row>

                    </Form>

                </div>
                {/* END COLUMN 1 FORM */}


            </div>
        </Container >
    );
};

export default DayVisitorForm;
